import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "../src/views/Dashbord/Dashbord";
import UserManager from "./views/UserMangemnet/UserManager";

import Login from "./views/Login/Login";
import { useEffect, useState } from "react";

import CityList from "./views/City/CityList";
import AreaList from "./views/area/AreaList";
import AssignSpeciality from "./views/AssignSpeciality/AssignSpeciality";
import HospitalList from "./views/hospital/HospitalList";
import SpecialityList from "./views/Speciality/SpecialityList";
import DoctorList from "./views/Doctor/DoctorList";
import RolesList from "./views/rolesmanagemnets/RolesList";
import ReportList from "./views/Report/ReportList";
import AppointmentList from "./views/Appoinments/AppoinmentsList";
import LoadingPage from "./views/LoadingPage/Loadingpage";
import { ProtectedRoutes } from "./views/ProtectedRoutes/ProtectedRoutes";

function App() {
  const AllRoutes = () => {
    return (
      <Routes>
        <Route
          path="/dashboard"
          element={<ProtectedRoutes name="dashboard" Component={Dashboard} />}
        />
        <Route
          path="/appoimnet-list"
          element={
            <ProtectedRoutes name="appointment" Component={AppointmentList} />
          }
        />
        <Route
          path="/user-list"
          element={
            <ProtectedRoutes name="userManagement" Component={UserManager} />
          }
        />
        <Route
          path="report-list"
          element={<ProtectedRoutes name="Report" Component={ReportList} />}
        />
        <Route
          path="/hospital-list"
          element={<ProtectedRoutes name="hospital" Component={HospitalList} />}
        />
        <Route
          path="/area-list"
          element={<ProtectedRoutes name="location" Component={AreaList} />}
        />
        <Route
          path="/speciality-list"
          element={
            <ProtectedRoutes name="speciality" Component={SpecialityList} />
          }
        />
        <Route
          path="/Master-speciality-list"
          element={
            <ProtectedRoutes
              name="assignSpeciality"
              Component={AssignSpeciality}
            />
          }
        />

        <Route
          path="/doctor-list"
          element={<ProtectedRoutes name="doctor" Component={DoctorList} />}
        />
        <Route
          path="/city-list"
          element={<ProtectedRoutes name="city" Component={CityList} />}
        />
        <Route path="/roles-list" Component={RolesList} />
      </Routes>
    );
  };

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/authentication/sign-in" element={<Login />} />
          <Route path="/Loading" element={<LoadingPage />} />
          <Route path="/*" element={<AllRoutes />} />
        </Routes>
      </Router>
    </>
  );
}
export default App;
